<template>
  <div class="scenicDetele">
    <div class="scenicTop">
      <div class="scenicTopTitle">{{ appoint.orgName }}</div>
      <div class="scenicTopNav">
        <div class="scenicTopItem">
          <span class="title">预约单号</span>
          <span class="content">{{ appoint.appointNo }}</span>
        </div>
        <div class="scenicTopItem">
          <span class="title">预约时间</span>
          <span class="content" v-if="appoint.createTime">{{ appoint.createTime|filt() }}</span>
        </div>
        <div class="scenicTopItem">
          <span class="title">入园时间</span>
          <span class="content" v-if="appoint.inParkDate">{{ appoint.inParkDate }} {{ appoint.inParkTime }}</span>
        </div>
      </div>
    </div>
    <div class="scenicHeight"></div>

    <!-- 行程单 -->
    <div class="scenicCenter" v-if="appointmentType == 'team'">
      <div class="scenicCenterBox">
        <div class="CenterTitle">行程信息</div>
      </div>
      <div class="scenicCenterBox">
        <div>旅⾏社</div>
        <div class="CenterContent">{{ appoint.travelAgentName }}</div>
      </div>
      <div class="scenicCenterBox">
        <div>线路</div>
        <div class="CenterContent">{{ appoint.lineName }}</div>
      </div>
      <div class="scenicCenterBox">
        <div>计调</div>
        <div class="CenterContent">{{ appoint.codeSendPerson }}</div>
      </div>
      <div class="scenicCenterBox">
        <div>行程单号</div>
        <div class="CenterContent">{{ appoint.travelItineraryNo }}</div>
      </div>
      <div class="scenicCenterClick">
        <div class="scenicCenterSearch">
          <span class="search" @click="appoint.travelItineraryNo ? goTravelDetail({
            path: '/travelAgency/tripDetail', query: {tripId: appoint.travelItineraryNo}
          }) : ''">查看行程单</span>
          <img src="../../../../assets/index/ic_time_bottom.png" alt />
        </div>
      </div>
    </div>
    
    <div class="scenicHeight"></div>
    <div class="scenicBottom">
      <div class="scenicBottomTitle">预约⼈数({{ touristList.length }}⼈)</div>
      <div class="scenicBottomContent" v-for="(item, ind) in touristList" :key="ind">
        <div class="scenicBottomLift">
          <div class="title">{{ item.touristName }}</div>
          <div class="tag_type">
            <div>{{ item.touristAgeTypeName }}</div>
          </div>
          <div class="risk high-rick" v-if="item.isEpidemicArea">
            {{ '高风险' }}
          </div>
          <!-- <div class="tag" v-if="item.touristAgeType === '儿童'">
            <div>
              {{ item.touristAgeType }}
            </div>
          </div>
          <div class="tag" v-if="item.touristAgeType === '残疾人'">
            <div>
              {{ item.touristAgeType }}
            </div>
          </div>-->
        </div>
        <div class="scenicBottomRight">{{ item.touristIdNumber }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "../../../../service/modules/appointment";
import { navigateToItineraryUniversal } from '@/router/navigate';

export default {
  data() {
    return {
      appointId: this.$route.params.appointId,
      appointmentType: this.$route.params.appointmentType,
      touristList: [],
      appoint: {}
    };
  },
  created() {
    this.getDeteleList();
  },
  methods: {
    getDeteleList() {
      api.appointInfo({ appointId: this.appointId }).then(res => {
        this.appoint = res.data;
        this.touristList = res.data.touristList;
      });
    },
    goTravelDetail(params) {
      let value = params.query;
      // let str = [];
      // for (let key in value) {
      //   str.push(key + "=" + value[key]);
      // }
      // let query = str.join("&");
      // window.yyn.invokeJSB(
      //   "openWindow",
      //   {
      //     openUrl: `${this.globalApp.getSystemInfo().host}web/#${
      //       params.path
      //     }?${query}`,
      //     isFullScreen: 0,
      //     setTitle: "",
      //     needLoading: 1
      //   },
      //   cb => {
      //     console.log(cb, "callback");
      //   }
      // );
      navigateToItineraryUniversal(value.tripId, 'team-supervision')
    }
  },

  filters: {
    filt(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
</script>

<style lang="less">
.scenicDetele {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background-color: #fbfbfb;
  .scenicTop {
    padding: 0 12px;
    background: #fff;
    .scenicTopTitle {
      font-size: 16px;
      padding: 16px 0 4px 0;
      color: #333;
      font-weight: 700;
    }
    .scenicTopNav {
      color: #999;
      .scenicTopItem {
        margin: 8px 0;
        .title {
          display: inline-block;
          width: 60px;
        }
        .content {
          display: inline-block;
        }
      }
    }
    .scenicTopNav:last-child {
      padding-bottom: 8px;
    }
  }
  .scenicHeight {
    height: 12px;
  }
  .scenicCenter {
    background: #fff;
    padding: 8px 12px 0;
    .scenicCenterBox {
      font-size: 14px;
      display: flex;
      padding: 8px 0;
      justify-content: space-between;
      .CenterTitle {
        font-weight: 700;
        color: #333;
      }
      .CenterContent {
        color: #333;
        font-style: 14px;
      }
    }
    .scenicCenterClick {
      height: 46px;
      line-height: 46px;
      text-align: center;
      display: flex;
      justify-content: space-around;
      .scenicCenterSearch {
        color: #36b374;
        .search {
          float: left;
          // margin-right: 4px;
          font-style: 12px;
        }
        img {
          float: right;
          display: inline-block;
          width: 10px;
          height: 6px;
          margin-top: 20px;
        }
      }
    }
  }

  .scenicBottom {
    background: #fff;
    padding: 0 12px 16px 12px;
    .scenicBottomTitle {
      font-size: 14px;
      padding: 16px 0;
      font-weight: 700;
      color: #333;
    }
    .scenicBottomContent {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      .scenicBottomLift {
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        .title {
          font-size: 14px;
          color: #333;
          font-weight: 400;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .tag {
          margin-left: 10px;
          color: #36b374;
          border: 1px solid #36b374;
          div {
            text-align: center;
            -webkit-transform: scale(0.84);
          }
        }
        .tag_type {
          margin-left: 10px;
          border: 1px solid #36b374;
          font-size: 10px;
          color: #36b374;
          background: white;
          padding: 4px;
          border-radius: 1px;
          div {
            text-align: center;
            -webkit-transform: scale(0.84);
            white-space: nowrap;
          }
        }
        .risk {
          margin-left: 4px;
          white-space: nowrap;
        }
        .high-rick {
          border: 1px solid #f94f4e;
          color: #f94f4e;
          font-size: 10px;
          background: white;
          padding: 4px;
          border-radius: 1px;
        }
        .medium-risk {
          border: 1px solid #ff8c19;
          color: #ff8c19;
          font-size: 10px;
          background: white;
          padding: 4px;
          border-radius: 1px;
        }
      }
      .scenicBottomRight {
        font-size: 14px;
        color: #333;
        font-weight: 400;
        margin-left: 5px;
      }
    }
  }
}
</style>
